module.exports = __webpack_public_path__ + "static/media/img-goal-12.c88d5918.jpg";